// extracted by mini-css-extract-plugin
export var container = "_54-0";
export var infoButton = "_54-1";
export var label = "_54-3";
export var labelExpanded = "_54-4";
export var price = "_54-5";
export var priceExpanded = "_54-6";
export var title = "_54-2";